import { Account, CompanyAccounts } from '@types';
import { useServiceResponse } from '@store';
import { useFetchRetrieveAccounts } from '@services';

export const useAccountSelectorHelper = () => {
	useFetchRetrieveAccounts();
	const { retrieveAccounts } = useServiceResponse();

	const companyAccountsData: CompanyAccounts[] | undefined =
		retrieveAccounts?.entityOut?.clientAccountStructureList?.map((company) => {
			return {
				companyName: company.name as string,
				accounts:
					company.accountList?.accountList?.map((account) => {
						return {
							id: account.id,
							name: account.name,
							number: account.accountNumber,
							accountableBalance: account.balance,
							availableBalance: account.availableBalance,
							iban: account.iban,
						} as Account;
					}) || [],
			};
		}) || undefined;

	return { companyAccountsData };
};
